import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'
export default {
    path: '/atomicClasses',
    name: 'AtomicClasses',
    meta: {
        title: '原子课管理',
        keepAlive: false
    },
    component: Layout,
    redirect: '/atomicClasses/atomicClassesIndex',
    children: [{
            path: 'atomicClassesIndex',
            name: 'AtomicClassesIndex',
            meta: {
                title: '原子课列表',
                keepAlive: true
            },
            component: resolve => require(['@/views/atomicClasses/atomicClasses/Index.vue'], resolve),
        },
        {
            path: 'atomicClassesIndex',
            name: 'atomicClassesIndex',
            meta: {
                title: '原子课列表',
                keepAlive: false
            },
            component: Empty,
            children: [{
                    path: 'AtomicClassAdd',
                    name: 'AtomicClassAdd',
                    meta: {
                        title: '编辑原子课',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomicClassAdd.vue'], resolve)

                },
                {
                    path: 'AtomicClassEdit',
                    name: 'AtomicClassEdit',
                    meta: {
                        title: '编辑原子课',
                        keepAlive: false
                    },
                    component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomicClassAdd.vue'], resolve)

                },
      
                {
                    path: 'AtomicClassAdd',
                    meta: {
                        title: '编辑原子课',
        
                    },
                    component: Empty,
                    children: [{
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassesCheck',
                        name: 'AtomClassesCheck',
                        meta: {
                            title: '选择知识点',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomClassesCheck.vue'], resolve)
        
                    },
                    
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassesCheck',
                        name: 'AtomClassesChecks',
                        meta: {
                            title: '选择知识点',
                            keepAlive: false
                        },
                        component: Empty,
                        children: [{
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassesCheck/knowledgDetailatomic',
                            name: 'knowledgDetailatomic',
                            meta: {
                                title: '预览知识点',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve)
                        }]
        
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/knowledgDetailatomics',
                        name: 'knowledgDetailatomics',
                        meta: {
                            title: '预览知识点',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/knowledge/knowledgeList/KnowledgDetail.vue'], resolve)
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/radioTestA1DetailAtomic',
                        name: 'radioTestA1DetailAtomics',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve)
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/radioTestA3DetailAtomic',
                        name: 'radioTestA3DetailAtomics',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve)
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/radioTestBDetail',
                        name: 'radioTestBDetailAtomics',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve)
                    },{
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/CheckedTestA1DetailAtomic',
                        name: 'CheckedTestA1DetailAtomics',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA1Detail.vue'], resolve),
        
                    },{
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/CheckedTestA4DetailAtomic',
                        name: 'CheckedTestA4DetailAtomics',
                        meta: {
                            title: '预览试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA4Detail.vue'], resolve),
        
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/testQuestionCheck',
                        name: 'AtomTestQuestionCheck',
                        meta: {
                            title: '选择试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/knowledge/knowledgeList/TestQuestionCheck.vue'], resolve)
        
                    },                
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion',
                        name: 'AtomClassTestQuestion',
                        meta: {
                            title: '筛选试题',
                            keepAlive: false
                        },
                        component: resolve => require(['@/views/atomicClasses/atomicClasses/AtomClassTestQuestion.vue'], resolve)
        
                    },
                    {
                        path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion',
                        name: 'AtomClassTestQuestionchild',
                        meta: {
                            title: '筛选试题',
                            keepAlive: false
                        },
                        component: Empty,
                        children: [{
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion/radioTestA1DetailAtomic',
                            name: 'radioTestA1DetailAtomic',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA1Detail.vue'], resolve)
                        },
                        {
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion/radioTestA3DetailAtomic',
                            name: 'radioTestA3DetailAtomic',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestA3Detail.vue'], resolve)
                        },
                        {
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion/radioTestBDetail',
                            name: 'radioTestBDetailAtomic',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/radioTest/RadioTestBDetail.vue'], resolve)
                        },{
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion/CheckedTestA1DetailAtomic',
                            name: 'CheckedTestA1DetailAtomic',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA1Detail.vue'], resolve),
            
                        },{
                            path: '/atomicClasses/atomicClassesIndex/AtomicClassAdd/AtomClassTestQuestion/CheckedTestA4DetailAtomic',
                            name: 'CheckedTestA4DetailAtomic',
                            meta: {
                                title: '预览试题',
                                keepAlive: false
                            },
                            component: resolve => require(['@/views/testBaseManage/checkedTest/CheckedTestA4Detail.vue'], resolve),
            
                        }]
        
                    }]
        
                }
            ]
        }
        
    ]
}